import makeStyles from '@mui/styles/makeStyles';

import { signupTokens } from '@/theme/colors';

export const useStyles = makeStyles({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  loadingStatus: {
    fontSize: 14,
    color: 'var(--onSurfaceMuted)',
    textAlign: 'center',
    padding: '24px 0',
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    margin: 0,
  },
  subtitle: {
    fontSize: 14,
    color: 'var(--onSurfaceMuted)',
    marginTop: 4,
  },
  errorText: {
    fontSize: 14,
    color: 'var(--errorText)',
    margin: 0,
  },
  domainMatchBanner: {
    backgroundColor: signupTokens.bannerSurface,
    border: `1px solid ${signupTokens.bannerBorder}`,
    borderRadius: 8,
    padding: 12,
    fontSize: 14,
    color: signupTokens.bannerText,
  },
  workspaceOwnerCallout: {
    backgroundColor: signupTokens.surfaceMuted,
    border: `1px solid ${signupTokens.borderNeutral}`,
    borderRadius: 6,
    padding: 12,
    fontSize: 12,
    color: signupTokens.textBodyDark,
    margin: 0,
  },
});
